import { helpWithOptions } from "./ConsolidatedGLCPFormOptions";
import { helpWithOptions as dataServicesOptions } from "@components/DataServiceCloudConsoleSupportForm/DSCCFormOptions";
import { ProductProps } from "@customTypes/types";

export const getProductPropsData = (helpWith, helpWithSecondary): ProductProps => {
    let product: ProductProps = {};

    if (helpWith === helpWithOptions.dataServices) {
      switch (helpWithSecondary) {
        case dataServicesOptions.backupAndRecovery:
          product.number = "R7A23AAE";
          product.name = "HPE GreenLake for Backup and Recovery Subscription SaaS";
          product.lineCode = "MU";
          product.type = "SAAS";
          break;
        case dataServicesOptions.blockStorage:
          product.number = "R9T02AAE";
          product.name = "HPE GreenLake for Block Storage IaaS";
          product.lineCode = "MW";
          product.type = "IAAS";
          break;
        case dataServicesOptions.dataObservability:
          product.number = "HPEGRLKDOPRE";
          product.name = "HPE GreenLake for Data Observability";
          product.lineCode = "00";
          product.type = "SAAS";
          break;
        case dataServicesOptions.disasterRecovery:
          product.number = "S1S62AAE";
          product.name = "HPE GreenLake for Disaster Recovery SaaS";
          product.lineCode = "2I";
          product.type = "SAAS";
          break;
        case dataServicesOptions.fileStorage:
          product.number = "S1F24A";
          product.name = "HPE Alletra Storage MP File Base Configuration";
          product.lineCode = "OR";
          product.type = "SAAS";
          break;
        case dataServicesOptions.cloudPhysics:
          product.number = "HPESUPINFANALYTICPRE";
          product.name = "HPE CloudPhysics Observer Software";
          product.lineCode = "00";
          product.type = "SAAS";
          break;
        case dataServicesOptions.privateCloudBusiness:
          product.number = "R9Q18AAE";
          product.name = "HPE GreenLake for Private Cloud Business Edition IaaS";
          product.lineCode = "6K";
          product.type = "IAAS";
          break;
        case dataServicesOptions.storageFabric:
          product.number = "R9R11AAE";
          product.name = "HPE GreenLake for Storage Fabric Management SaaS";
          product.lineCode = "8Q";
          product.type = "IAAS";
          break;
        default:
          break;
      }
    }

    if (helpWith === helpWithOptions.computeOpsManagement) {
      product.number = "R6Z73AAE";
      product.name = "HPE GreenLake for Compute Ops Management Base SaaS";
      product.lineCode = "S3";
      product.type = "SAAS";
    }

    if (helpWith === helpWithOptions.computeOpsManagement) {
      product.number = "R6Z73AAE";
      product.name = "HPE GreenLake for Compute Ops Management Base SaaS";
      product.lineCode = "S3";
      product.type = "SAAS";
    }

    return product;
};
